export const environment = {
  production: true,
  securityApiUrl: 'https://hermes.bantrab.com:2096/v2/',
  apiPivote: 'https://hermes.bantrab.com:2096',
  baseUser: 'P3rS0n4L1z4C10n.0b@B4nTr4b',
  basePassword: 'MoyYhmb2ay2H8uEqCdmBtwoXj2k4aD6xVwjnqIOiH9ivRULreQkQp39VhjUAzkG0',
  autogestionUser: 'Autogestion',
  autogestionPassword: 'eR47XcxItku/5oBuLj8Kws+rKqvrMXciaKLxAkjbz6COP5cS6nQiC9n3WMupGq1w',
  agentestoken: 'bBW1rVPkdqRxmo94LcJbI6Fp13g9hF27'
};
